import React, { useEffect, useState } from "react";
import "../Categories/Categories.css";
import DashboardHeader from "../../../Components/header/DashboardHeader";
import { CiSearch } from "react-icons/ci";
import { nano_technology } from "../../../assets";
import { Link, useNavigate } from "react-router-dom";
import { fetchCategoriesListApi } from "../../../services/common";
import useDebounce from "../../../hooks/useDebounce";
import { encryptData } from "../../../utils/dataCipher";
import { nestedArray } from "../../../utils/staticData";

const Categories = () => {
  const navigate = useNavigate();
  const [categoryList, setCategoryList] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
// console.log('categoryList', categoryList)
  //   Fetching Category List
  const fetchCategoryList = async () => {
    try {
      const { data } = await fetchCategoriesListApi({ search: debouncedValue });
      const { success, data: response } = data;
      if (success) {
        setCategoryList(response);
      } else {
        setCategoryList([]);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  useEffect(() => {
    fetchCategoryList();
  }, [debouncedValue]);


  // Recursive function to render nested lists
  const renderList = (items) => {
    return (
      <ul>
        {items?.map((item, index) => (
          <li key={index}>
            {Array.isArray(item) ? renderList(item) : item}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <DashboardHeader title={"Overview"} />

      <div className="categories_parent">
        <div className="msg_list_search-bar">
          <input
            type="text"
            className="msg-search-input"
            placeholder="Search here"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <CiSearch className="search_icon" />
        </div>



        <div className="categories_list_types">
          {categoryList && categoryList.length > 0
            ? categoryList.map((data, i) => (
              <div key={i} className="technologies_list" onClick={() => navigate(`/dashboard/category/group-list?info=${encryptData(data)}`)}>
                <Link >
                  <img src={data?.image} />
                  <span className="tech_list_name">{data?.name}</span>
                </Link>
              </div>
            ))
            : null}
        </div>
        {/* {renderList(nestedArray)} */}
      </div>
    </>
  );
};

export default Categories;
